import { MERCHANT_LOGOS_GET_SUCCESS, MERCHANT_LOGOS_GET_FAILURE } from '../actions/types';
import config from '../configs';

const initialState = {
  config,
  isLoading: false,
  isLoaded: false,
  placement: [],
};

const merchantLogos = (state = initialState, action) => {
  switch (action.type) {
    case MERCHANT_LOGOS_GET_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        placement: action.payload.response,
      };
    }
    case MERCHANT_LOGOS_GET_FAILURE: {
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        placement: [],
      };
    }
    default: {
      const { options = {} } = action;

      if (options.success === MERCHANT_LOGOS_GET_SUCCESS) {
        return {
          ...state,
          isLoading: true,
          isLoaded: false,
        };
      }

      return state;
    }
  }
};

export default merchantLogos;
